import { Microscope } from 'lucide-react';
import type { LabTestTVitalLabTestMetadataTVitalLabMarkerMetadataT as LabTestT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { Button } from '@/shared/ui/shadcn/button';

import { LabTestSearch } from '../selectors/LabTestSearch.js';

export interface SelectTestStepProps {
  onSelectLabTest: (labTest: LabTestT) => void;
  onCreateNew: () => void;
}

export function SelectTestStep({ onSelectLabTest, onCreateNew }: SelectTestStepProps) {
  return (
    <LabTestSearch
      onSelect={onSelectLabTest}
      action={
        <Button
          type="button"
          variant="secondary"
          size="sm"
          className="shrink-0 whitespace-nowrap"
          onClick={onCreateNew}
        >
          <Microscope className="mr-1 size-3.5" />
          Create New
        </Button>
      }
    />
  );
}
